import i18n from '@/lang';
/* unplugin-vue-components disabled */
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', [_c('div', {
    staticClass: "order-item",
    class: {
      card: _vm.isCard,
      translate: _vm.isShow && _vm.swipe
    },
    style: {
      height: _vm.miniStyle.height,
      padding: _vm.miniStyle.padding,
      transform: "translate3d(" + this.deltaX + ", 0px, 0px)"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "font-size-h3-large smy__text-overflow-one-line title"
  }, [_c('div', {
    staticClass: "content smy__text-overflow-one-line"
  }, [_vm._t("title")], 2)])]), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "right-tip"
  }, [_c('div', {
    staticClass: "status font-size-h3-normal"
  }, [_vm._t("tip")], 2), _c('div', {
    staticClass: "timeout font-size-h4-normal"
  })]), _c('div', {
    staticClass: "font-size-h4-large no"
  }, [_vm._t("no")], 2), _c('div', {
    staticClass: "font-size-h4-large time"
  }, [_vm._t("time")], 2), _c('div', {
    staticClass: "font-size-h4-large customer"
  }, [_vm._t("customer")], 2), _c('div', {
    staticClass: "font-size-h4-large address smy__text-overflow-one-line"
  }, [_vm._t("address")], 2), _vm._t("default")], 2)]), _vm.swipe ? _c('div', {
    staticClass: "button"
  }, [_c('div', {
    staticClass: "delete",
    on: {
      "click": function ($event) {
        _vm.$emit('delete', $event);
        $event.stopPropagation();
      }
    }
  }, [_vm._v(" " + i18n.tc("280") + " ")])]) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };